import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import Badge from '@mui/material/Badge';
import HomeIcon from '@mui/icons-material/Home';
import ViewListIcon from '@mui/icons-material/ViewList';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MessageIcon from '@mui/icons-material/Message';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';
import { MAIN_COLOR, FONT_FAMILY, client } from '../common/sharedFunctions';
import { colors } from './Theme/WebTheme';

const navItems = [
  { label: 'home', path: '/', icon: <HomeIcon /> },
  { label: 'booking_history', path: '/bookings', icon: <ViewListIcon /> },
  { label: 'addbookinglable', path: '/addbookings', icon: <AddCircleOutlineIcon />, isCta: true },
  { label: 'messages', path: '/chats', icon: <MessageIcon />, showBadge: true },
  { label: 'profile', path: '/profile', icon: <AccountCircleIcon /> },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (client && client.userID) {
      client.getUnreadCount().then(res => {
        setUnreadCount(res.total_unread_count || 0);
      }).catch(() => {});
      const handler = client.on('message.new', () => {
        client.getUnreadCount().then(res => {
          setUnreadCount(res.total_unread_count || 0);
        }).catch(() => {});
      });
      return () => handler.unsubscribe();
    }
  }, [client?.userID]);

  const currentIndex = navItems.findIndex(item => {
    if (item.path === '/') return location.pathname === '/';
    return location.pathname.startsWith(item.path);
  });
  const value = currentIndex >= 0 ? currentIndex : 0;

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      }}
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          navigate(navItems[newValue].path);
        }}
        sx={{
          backgroundColor: MAIN_COLOR,
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            color: 'rgba(255,255,255,0.6)',
            minWidth: 'auto',
            padding: '6px 0',
            fontFamily: FONT_FAMILY,
            transition: 'color 0.2s ease, transform 0.15s ease',
            '&.Mui-selected': {
              color: '#ffffff',
              transform: 'scale(1.05)',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.65rem',
            fontFamily: FONT_FAMILY,
            '&.Mui-selected': {
              fontSize: '0.7rem',
            },
          },
        }}
        showLabels
      >
        {navItems.map((item, index) => {
          let icon = item.icon;

          if (item.showBadge && unreadCount > 0) {
            icon = (
              <Badge badgeContent={unreadCount} color="error" max={99}>
                {item.icon}
              </Badge>
            );
          }

          if (item.isCta) {
            icon = (
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '50%',
                  width: 44,
                  height: 44,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: -10,
                  boxShadow: '0 2px 8px rgba(255, 255, 255, 0.3)',
                }}
              >
                <AddCircleOutlineIcon sx={{ color: MAIN_COLOR, fontSize: 28 }} />
              </div>
            );
          }

          return (
            <BottomNavigationAction
              key={item.path}
              label={item.isCta ? '' : t(item.label)}
              icon={icon}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
}
